import CustomButton from "components/CustomButton";
import CustomModal from "components/CustomModal";
import Input from "components/form/Input";
import { ImageUploadCard } from "components/ImageUploadCard";
import BrandSearchSelect from "components/selects/BrandSearchSelect";
import BrandWeekSelect from "components/selects/BrandWeekSelect";
import CampaignProductSelect from "components/selects/CampaignProductSelect";
import CategorySearchSelect from "components/selects/CategorySearchSelect";
import DynamicPagesSelect from "components/selects/DynamicPagesSelect";
import LabeledSelect from "components/selects/LabeledSelect";
import ProductSearchSelect from "components/selects/ProductSearchSelect";
import SpecialBrandsSelect from "components/selects/SpecialBrandsSelect";
import { isFromOrigin } from "helpers/helperFunctions";
import { isObjectEmpty } from "helpers/objectHelper";
import { getReverseFormattedSeoUrl } from "helpers/seoHelper";
import { getFormattedSeoUrl } from "helpers/seoHelper";
import { isNotEmpty } from "helpers/stringHelper";
import isEmpty from "lodash/isEmpty";
import { displayBrandWeekSearch, displayCampaignSearch, displayCategorySearch, displayBrandSearch, displayProductSearch, displayBrandDaySearch, displayProductCampaign } from "pages/banners/components/constants";
import { groupOptions } from "pages/banners/components/constants";
import { PRODUCT_CAMPAIGN_TYPE } from "pages/focusItems/enums";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { tryGetActiveFlashSale } from "redux/slices/bannerSlices";
import { tryUpdateCandidate } from "redux/slices/predictionSlice";
import { tryCreateCandidate } from "redux/slices/predictionSlice";
import { PREDICTION_OTHERS_LIST } from './constant';


export default function PredictionCandidateForm({ loading, showModal, setShowModal }) {
  const dispatch = useDispatch()

  const {
    flashSale
  } = useSelector((state) => state.banner);


  const [name, setName] = useState("");
  const [image, setImage] = useState({
    app_image_url: '',
    web_image_url: ''
  });

  const [selectedGroup, setSelectedGroup] = useState({});
  const [group, setGroup] = useState('');
  const [subGroup, setSubGroup] = useState('');
  const [anylink, setAnyLink] = useState('')

  const groupSelectionOption = [...groupOptions, ...PREDICTION_OTHERS_LIST]

  // common for all search/select
  const [selectedOption, setSelectedOption] = useState(null);
  const [ext, setExt] = useState();
  const [seoDetail, setSeoDetail] = useState({});

  useEffect(() => {
    if (!isEmpty(showModal) && !isEmpty(showModal.prediction_category_id)) {
      if (showModal?.meta?.action_url) {
        const url = new URL(showModal?.meta?.action_url);
        let groupAndSubGroup = url.pathname.slice(1).split('/');
        const productsSubGroup = groupOptions[0].subGroupOptions.map(
          (option) => option.value
        );
        const selectedOption = groupOptions.filter(
          (option) => option.value === groupAndSubGroup[0]
        );
        resetIdTitleAndSelectedOption();

        if (
          groupAndSubGroup[0] === 'products' &&
          !productsSubGroup.includes(groupAndSubGroup[1])
        ) {
          setSubGroup('details');
        } else if (
          groupAndSubGroup[0] === 'brands' &&
          groupAndSubGroup[1] === undefined
        ) {
          setSubGroup('normal');
        } else if (
          groupAndSubGroup[0] === 'brands' &&
          groupAndSubGroup[1] !== 'featured'
        ) {
          setSubGroup('campaign');
        } else {
          setSubGroup(groupAndSubGroup[1]);
        }
        if (selectedOption[0]) {
          setSelectedGroup(selectedOption[0]);
          setGroup(selectedOption[0].value);
          const { name, id } = getReverseFormattedSeoUrl(
            groupAndSubGroup[groupAndSubGroup.length - 1]
          );
          if (selectedOption[0].label !== "Brands") {
            if (
              groupAndSubGroup[0] === 'products' &&
              !productsSubGroup.includes(groupAndSubGroup[1])
            ) {
              // setSelectedOption({id, label: name})
              setExt({ id, label: name });
            } else {
              setExt({ id, name });
              // setSelectedOption({id, name})
            }
          }

        } else {
          if (isFromOrigin(showModal?.meta?.action_url)) {
            setGroup("pages");
            const { name, id } = getReverseFormattedSeoUrl(
              groupAndSubGroup[groupAndSubGroup.length - 1]
            );
            setExt({ id, label: name });
          } else {
            setGroup("any_link")
            setAnyLink(showModal?.meta?.action_url)
          }

        }
      } else {
        setGroup('no_link')
      }
      setImage({
        app_image_url: showModal.app_image_url,
        web_image_url: showModal.web_image_url
      })
      setName(showModal?.name)
    }
  }, [showModal])

  useEffect(() => {
    if (isEmpty(showModal)) {
      resetForm()
    }
    return () => {
      resetForm()
    }
  }, [showModal])

  const processing = false;
  const onSubmit = () => {
    const url = generateSeoUrl(seoDetail, group, subGroup);
    dispatch(tryCreateCandidate(
      {
        id: showModal.id,
        payload: {
          name,
          ...image,
          ...(group !== 'no_link' && {
            meta: {
              ...(group !== 'no_link' && {
                action_url: group !== "any_link" ? url : anylink
              })
            }
          })

        }
      }))
  }

  const onUpdate = () => {
    const url = generateSeoUrl(seoDetail, group, subGroup);
    dispatch(tryUpdateCandidate(
      {
        id: showModal.id,
        payload: {
          name,
          ...image,
          meta: {
            ...(group !== 'no_link' && {
              action_url: group !== "any_link" ? url : anylink
            })
          }
        }
      }))
  }

  const onSetSelectedItem = (item) => {
    setSeoDetail(item);
    setSelectedOption(item);
  };

  const resetIdTitleAndSelectedOption = () => {
    setSelectedOption(null);
  };

  const resetForm = () => {
    setSelectedGroup({});
    setGroup('');
    setImage({
      app_image_url: '',
      web_image_url: ''
    })
    resetIdTitleAndSelectedOption();
    setSeoDetail({});
    setExt();
    setName("")
    setAnyLink("")
  };


  const isEdit = showModal?.hasOwnProperty("prediction_category_id")

  const isAllValid = () => {
    const isImageValid = isNotEmpty(image.app_image_url) && isNotEmpty(image.web_image_url);

    const commonValid = isImageValid && isNotEmpty(name);

    switch (group) {
      case 'products':
        if (
          subGroup === 'categories' ||
          subGroup === 'brand' ||
          subGroup === 'details' ||
          subGroup === 'brand_day' ||
          subGroup === 'brand_week'
        ) {
          return (
            commonValid && isNotEmpty(subGroup) && selectedOption !== null
          );
        } else {
          return commonValid && isNotEmpty(subGroup);
        }
      case 'brands':
        if (subGroup === 'campaign') {
          return (
            commonValid && isNotEmpty(subGroup) && isNotEmpty(seoDetail?.id)
          );
        } else {
          return commonValid && isNotEmpty(subGroup);
        }
      case 'flash-sale':
        if (flashSale.data !== null) {
          return (
            commonValid &&
            isNotEmpty(subGroup) &&
            isNotEmpty(flashSale.data?.id.toString())
          );
        } else {
          return false;
        }
      case 'product-campaigns':
        return commonValid && isNotEmpty(subGroup) && selectedOption !== null;
      case 'pages':
        return commonValid && !isEmpty(seoDetail);
      case 'no_link':
        return commonValid
      case 'any_link':
        return commonValid && isNotEmpty(anylink)
      default:
        return false;
    }
  };


  return (
    <>
      <CustomModal
        title="Add Prediction Candidate " showModal={!!showModal}
        button={
          <CustomButton onClick={isEdit ? onUpdate : onSubmit} disabled={loading || !isAllValid()}>
            {isEdit ? 'Update' : 'Create'}
          </CustomButton>
        }
        setShowModal={() => {
          setShowModal()
          resetForm()
        }}
        loading={loading}
      >
        <div className="flex space-x-4">
          <div className="flex-1">
            <ImageUploadCard
              title="App Banner Image"
              initialImage={image.app_image_url}
              onImageUploaded={(uploaded) => {
                setImage({ ...image, app_image_url: uploaded })
              }}
              onImageRemoved={(uploaded) => {
                setImage({ ...image, app_image_url: uploaded })
              }}
            />

            <ImageUploadCard
              title="Web Banner Image"
              initialImage={image.web_image_url}
              onImageUploaded={(uploaded) => {
                setImage({ ...image, web_image_url: uploaded })
              }}
              onImageRemoved={(uploaded) => {
                setImage({ ...image, web_image_url: uploaded })
              }}
            />
          </div>
          <div className="flex-1 flex flex-col">
            <Input
              type="text"
              color="blue"
              placeholder="Title"
              value={name}
              onChange={(e) => {
                setName(e.target.value)
              }}
            />
            <>
              <LabeledSelect
                label="Select Group"
                placeholder="Search Group"
                options={groupSelectionOption}
                value={groupSelectionOption.find((o) => o.value === group) ?? ''}
                onChange={(selectedOption) => {
                  setSelectedGroup(selectedOption);
                  setGroup(selectedOption.value);
                  setSubGroup('');
                  resetIdTitleAndSelectedOption();
                  if (selectedOption.value === 'flash-sale') {
                    setSeoDetail({});
                    dispatch(tryGetActiveFlashSale());
                  }
                }}
              />

              {group !== 'flash-sale' &&
                group !== 'product-campaigns' &&
                group !== 'pages' && group !== 'no_link' && group !== 'any_link' &&
                <LabeledSelect
                  label={`Select Sub Group`}
                  placeholder="Search Sub Group"
                  options={selectedGroup.subGroupOptions}
                  isDisabled={isObjectEmpty(selectedGroup)}
                  value={
                    selectedGroup?.subGroupOptions?.find(
                      (o) => o.value === subGroup
                    ) ?? ''
                  }
                  onChange={(selectedOption) => {
                    setSubGroup(selectedOption.value);
                    onSetSelectedItem();
                    resetIdTitleAndSelectedOption();
                  }}
                  maxHeight={120}
                />
              }

              {
                group === 'product-campaigns' && (
                  <LabeledSelect
                    label={'Select Campaign Type'}
                    value={PRODUCT_CAMPAIGN_TYPE.find(
                      (t) => t.value === subGroup
                    )}
                    options={PRODUCT_CAMPAIGN_TYPE}
                    placeholder={'Select Campaign Type'}
                    onChange={(v) => {
                      setSelectedOption(null);
                      setSubGroup(v.value);
                    }}
                  />
                )
              }

              {
                group === 'pages' &&
                <DynamicPagesSelect
                  label="Select a Dynamic Page"
                  value={selectedOption}
                  extData={ext?.id}
                  onChange={(page) => {
                    onSetSelectedItem(page);
                  }}
                />

              }


              {/*Brand search section*/}
              {displayBrandSearch(group, subGroup) && (
                <BrandSearchSelect
                  label="Select Brand"
                  isDisabled={processing}
                  value={selectedOption}
                  extData={ext?.id}
                  onChange={(brand) => onSetSelectedItem(brand)}
                />
              )}

              {/*Product search section*/}
              {displayProductSearch(group, subGroup) && (
                <ProductSearchSelect
                  label="Select Product"
                  isDisabled={processing}
                  extData={ext?.id}
                  value={selectedOption}
                  onChange={(product) => onSetSelectedItem(product)}
                />
              )}

              {/*Category search section*/}
              {displayCategorySearch(group, subGroup) && (
                <CategorySearchSelect
                  label="Select Category"
                  isDisabled={processing}
                  value={selectedOption}
                  extData={ext?.id}
                  onChange={(category) => onSetSelectedItem(category)}
                />
              )}

              {displayCampaignSearch(group, subGroup) && (
                <SpecialBrandsSelect
                  label="Select Campaign Month"
                  isBrandDay={false}
                  value={selectedOption}
                  extData={ext?.id}
                  onChange={(campaign) => onSetSelectedItem(campaign)}
                />
              )}

              {displayBrandDaySearch(group, subGroup) && (
                <SpecialBrandsSelect
                  label="Select Brand Day"
                  emptyMsg="No brand day available"
                  extData={ext?.id}
                  isBrandDay={true}
                  value={selectedOption}
                  onChange={(brand) => onSetSelectedItem(brand)}
                />
              )}

              {displayBrandWeekSearch(group, subGroup) && (
                <BrandWeekSelect
                  extData={ext?.id}
                  label="Select Brand Week"
                  emptyMsg="No brand week available"
                  value={selectedOption}
                  onChange={(brand) => onSetSelectedItem(brand)}
                />
              )}

              {displayProductCampaign(group, subGroup) && (
                <CampaignProductSelect
                  label="Search Product Campaign"
                  value={selectedOption}
                  onChange={(campaign) => {
                    onSetSelectedItem(campaign);
                  }}
                  type={subGroup}
                />
              )}
              {group === 'any_link' &&
                <Input
                  type="text"
                  color="blue"
                  label="Link (must be a valid https:// url)"
                  placeholder="Eg: https://example.com"
                  value={anylink}
                  onChange={(e) => {
                    setAnyLink(e.target.value.trim())
                  }}
                />

              }              {group === 'flash-sale' && (flashSale.loading ?
                <div>'Checking active flash sale...'</div> : flashSale.error ?
                  <div>'Checking active flash sale...'</div>
                  : flashSale.data !== null ?
                    <LabeledSelect
                      label="Select Sub Group"
                      placeholder="Search Sub Group"
                      options={selectedGroup.subGroupOptions}
                      isDisabled={isObjectEmpty(selectedGroup)}
                      value={
                        selectedGroup?.subGroupOptions?.find(
                          (o) => o.value === subGroup
                        ) ?? ''
                      }
                      onChange={(selectedOption) => {
                        setSubGroup(selectedOption.value);
                        resetIdTitleAndSelectedOption();
                      }}
                      maxHeight={120}
                    /> :

                    <div>No Flash Sale currently running</div>
              )}

            </>
          </div>
        </div>
      </CustomModal>
    </>
  );

}

export function generateSeoUrl(seoDetail, group, subGroup) {
  const bannedSubGroup = ['details', 'campaign', 'normal', 'discount'];
  const bannedGroup = ['pages'];

  let actionUrl = `${process.env.REACT_APP_DOMAIN}`;

  if (!bannedGroup.includes(group))
    actionUrl = actionUrl.concat(`/${group}`);

  if (!bannedSubGroup.includes(subGroup) && subGroup?.length) {
    actionUrl = actionUrl.concat(`/${subGroup.toLowerCase()}`);
  }

  if (!isEmpty(seoDetail)) {
    let slugUrl = getFormattedSeoUrl({
      seoDetails: seoDetail?.seo_details,
      title: seoDetail.label ?? seoDetail.name ?? seoDetail.title,
      id: seoDetail.product_id ?? seoDetail.id ?? ''
    });
    actionUrl = actionUrl.concat(`/${slugUrl}`);
  }
  if (seoDetail?.name ?? false) {
    actionUrl = actionUrl.concat(`?title=${seoDetail.name}`);
  }
  return actionUrl;
};


